module.exports = __webpack_public_path__ + "img/CleaningServicesOutlined.57f3cbfe.svg";